var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h2',{staticClass:"page-not-found"},[_vm._v("Page not found")])
}
var staticRenderFns = []

export { render, staticRenderFns }